import { useTheme } from '../contexts/ThemeContext';

const LOGO_VERSION = 'v=4'; // bump when logo changes to force cache refresh

export const ThemeLogo = ({ className = '', style = {} }) => {
    const { isDark } = useTheme();
    return (
        <div className={`relative ${className}`} style={style}>
            <img
                src={`/logo.png?${LOGO_VERSION}`}
                alt="MacTech - Uygulama Ekosistemi"
                className="h-full w-auto"
                loading="eager"
                width="200"
                height="200"
                style={{
                    opacity: isDark ? 1 : 0,
                    position: isDark ? 'relative' : 'absolute',
                    top: 0,
                    left: 0,
                }}
            />
            <img
                src={`/logo-light.png?${LOGO_VERSION}`}
                alt="MacTech - Uygulama Ekosistemi"
                className="h-full w-auto"
                loading="eager"
                width="200"
                height="200"
                style={{
                    opacity: isDark ? 0 : 1,
                    position: isDark ? 'absolute' : 'relative',
                    top: 0,
                    left: 0,
                }}
            />
        </div>
    );
};
